import React from 'react';
import { Phone, MapPin, Calendar } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-179">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-180">
        <img src="https://oldmillrestaurant.ie/wp-content/uploads/photo-gallery/imported_from_media_libray/34367997_1963635710348411_6426394423512268800_n.jpg?bwg=1552561670" alt="The Old Mill Restaurant Interior" className="w-full h-full object-cover" data-id="element-181" />
        {/* Dark Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-background" data-id="element-182"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center pt-20" data-id="element-183">
        <div className="animate-fade-in-up space-y-6 max-w-4xl mx-auto" data-id="element-184">
          <p className="text-primary font-bold tracking-[0.2em] uppercase text-sm md:text-base mb-4" data-id="element-185">
            Temple Bar, Dublin
          </p>

          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight mb-6" data-id="element-186">
            Traditional Irish Food <br className="hidden md:block" data-id="element-187" />
            in Temple Bar
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 font-light" data-id="element-188">
            Breakfast, Lunch & Dinner • Full Bar • Walk-ins Welcome
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 w-full max-w-md md:max-w-none mx-auto" data-id="element-189">
            <a href="#reservation" className="w-full md:w-auto px-8 py-4 bg-primary text-primary-foreground font-bold rounded-md hover:bg-primary/90 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(var(--primary),0.4)] flex items-center justify-center gap-2" data-id="element-190">
              <Calendar className="w-5 h-5" data-id="element-191" />
              Book a Table
            </a>

            <a href="tel:+35316719266" className="w-full md:w-auto px-8 py-4 border-2 border-primary text-primary font-bold rounded-md hover:bg-primary/10 transition-all flex items-center justify-center gap-2" data-id="element-192">
              <Phone className="w-5 h-5" data-id="element-193" />
              Call Now
            </a>

            <a href="https://www.google.com/maps/dir/?api=1&destination=14+Temple+Bar+Square+Dublin+2+Ireland" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-8 py-4 border-2 border-primary text-primary font-bold rounded-md hover:bg-primary/10 transition-all flex items-center justify-center gap-2" data-id="element-194">
              <MapPin className="w-5 h-5" data-id="element-195" />
              Get Directions
            </a>
          </div>

          {/* Trust Row */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap items-center justify-center gap-4 text-sm md:text-base text-muted-foreground" data-id="element-196">
            <span data-id="element-197">Temple Bar</span>
            <span className="w-1 h-1 rounded-full bg-primary" data-id="element-198"></span>
            <span data-id="element-199">Dublin 2</span>
            <span className="w-1 h-1 rounded-full bg-primary" data-id="element-200"></span>
            <span className="flex items-center gap-2" data-id="element-201">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-202"></span>
              Open Daily 09:00–22:30
            </span>
          </div>
        </div>
      </div>
    </section>;
}